// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__YAkPs","footer":"ModalInfo_footer__1s6ZL"};